import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import './EventTracker.css'

const EventTrackerPageUI = ({ 
  context, 
  account,
  events = [],
  loading,
  error,
  onRefreshClick,
  onViewEvent,
  onApproveEvent,
  onRejectEvent,
  isNotificationEnabled,
  onNotificationToggle,
  showConfirmationPopup,
  onConfirmNotification,
  onCancelNotification,
  notificationToggleLoading,
  onDownload,
  currentPage,
  totalPages,
  onPageChange,
}) => (
  <SuperUserAccountPageUI 
    context={context} 
    className='pg_su_acc' 
    backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} 
    dimension='w768'
    centered={!account} 
    account={account} 
    page='eventTracker'
  >
    {!account && loading && <SpinnerComponentUI />}

    {error && (
      <div className="g_error g_m_top_30">{error}</div>
    )}

    {account && (
      <div>
        <div className="event-tracker-header">
          <h2 className="event-tracker-title">Event tracker</h2>
          {/* <div className="notification-toggle-container">
            <span className="notification-label">Enable notification</span>
            <label className="toggle-switch">
              <input 
                type="checkbox" 
                checked={isNotificationEnabled} 
                onChange={onNotificationToggle}
                disabled={notificationToggleLoading}
              />
              <span className="toggle-slider"></span>
            </label>
            {notificationToggleLoading && <SpinnerComponentUI size="small" />}
          </div> */}
        </div>
        
        {/* Confirmation Popup */}
        {showConfirmationPopup && (
          <div className="confirmation-popup-overlay">
            <div className="confirmation-popup">
              <h3>Confirm Action</h3>
              <p>Are you sure you want to {isNotificationEnabled ? 'disable' : 'enable'} notifications?</p>
              <div className="confirmation-buttons">
                <button className="cancel-button" onClick={onCancelNotification}>No</button>
                <button className="confirm-button" onClick={onConfirmNotification}>Yes</button>
              </div>
            </div>
          </div>
        )}
        
        {loading ? (
          <div className="g_center g_m_top_30">
            <SpinnerComponentUI />
          </div>
        ) : events.length === 0 ? (
          <div className="g_center g_m_top_30">
            <p className="g_muted_event">No events found for this account.</p>
          </div>
        ) : (
          <div className="event-tracker-list">
            {events.map((eventData) => {
              // Extract data from the new nested structure
              const trackerData = eventData.tracker;
              // Create an event object with the structure the UI component expects
              const event = {
                id: trackerData.trackerId,
                name: (trackerData.eventType) ? trackerData.eventType : 'Unknown Event',
                // name: (trackerData.event && trackerData.event.eventName) ? trackerData.event.eventName : 'Unknown Event',
                timestamp: trackerData.createdAt,
                status: trackerData.status,
                reviewStatus: trackerData.reviewStatus,
                reviewReason: trackerData.reviewReason,
                whatsAppInfo: eventData.whatsAppConversation,
                // Include the original data for reference if needed
                trackerData: trackerData,
                whatsAppData: eventData.whatsAppConversation
              };
              return (
                <EventTrackerItem 
                  key={event.id} 
                  event={event}
                  onView={() => onViewEvent(event.id)}
                  onApprove={() => onApproveEvent(event.id)}
                  onReject={() => onRejectEvent(event.id)}
                  onDownload={() => onDownload(event.trackerData.documentList[0])}
                />
              );
            })}
          </div>
        )}

        {totalPages > 1 && (
          <div className="pagination-controls g_m_top_20 g_center">
            <button 
              onClick={() => onPageChange(currentPage - 1)} 
              disabled={currentPage === 1}
              className="pagination-button"
            >
              Previous
            </button>
            <span className="pagination-info">
              Page {currentPage} of {totalPages}
            </span>
            <button 
              onClick={() => onPageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
              className="pagination-button"
            >
              Next
            </button>
          </div>
        )}
      </div>
    )}
  </SuperUserAccountPageUI>
)

const EventTrackerItem = ({ event, onView, onApprove, onReject, onDownload }) => {
  const getFormattedDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
  };

  // const needsReview = event.trackerData.event.requiresApproval;

  const documentList = event.trackerData.documentList;
  
  return (
    <div className="event-tracker-item">
      <div className="event-info">
        <h3 className="event-title">{event.name}</h3>
        {/*<p className="event-id" style={{ marginTop: '0px' }}>Loan ID: {event.trackerData.loanId}</p>*/}
        <p className="event-id" style={{ marginTop: '-5px' }}>Delivery Channel: {event.trackerData.deliveryChannel}</p>
        <p className="event-date" style={{ marginTop: '-5px' }}>Created: {getFormattedDate(event.timestamp)}</p>
        <p className="event-status" style={{ marginTop: '-5px' }}>Status: {event.status}</p>
        
        {event.reviewStatus && (
          <p className="review-status" style={{ marginTop: '-5px' }}>Review Status: {event.reviewStatus}</p>
        )}
        
        {event.reviewReason && (
          <p className="review-reason" style={{ marginTop: '-5px' }}>Reason: {event.reviewReason}</p>
        )}
      </div>
      
      <div className="event-actions">
        {/* {needsReview && (
          <>
          <button className="event-button view" onClick={onView}>View</button>
            <button className="event-button approve" onClick={onApprove}>Approve</button>
            <button className="event-button reject" onClick={onReject}>Reject</button>
          </>
        )} */}
        {documentList && documentList.length > 0 && (
          <button className="event-button download" onClick={() => onDownload(event.trackerData.documentList[0])}>
            {/* <div className="download-icon"> */}
              {/* <IconButtonUI icon="icon-download" /> */}
            {/* </div> */}
            Download
          </button>
        )}
      </div>
    </div>
  );
};

export default EventTrackerPageUI
